const isPlainObject = (value) =>
  Object.prototype.toString.call(value) === "[object Object]";

export const toastrApiErrors = (error, fallbackMessage) => {
  const response = error && error.response;
  const data = response && response.data;

  const hasFieldErrors =
    response &&
    response.status < 500 &&
    isPlainObject(data) &&
    Object.keys(data).length > 0;

  if (!hasFieldErrors) {
    toastr.error(fallbackMessage);
    return;
  }

  Object.entries(data).forEach(([key, messages]) => {
    toastr.error(`${key.replace(/_/g, " ")} ${[].concat(messages).join(", ")}`);
  });
};
